<div class="chart-container">
  <div *ngIf="isLoading" class="loading">
    Loading chart data...
  </div>
  <div *ngIf="!isLoading" id="chart">
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [labels]="chartOptions.labels"
      [fill]="chartOptions.fill"
      [legend]="chartOptions.legend"
      [dataLabels]="chartOptions.dataLabels"
      [responsive]="chartOptions.responsive"
      [plotOptions]="chartOptions.plotOptions"
    ></apx-chart>
  </div>
</div>
